module.exports = __webpack_public_path__ + "static/2-04be0752a8fb4d739344c6fe55dc8e19.png";